export default "__VITE_ASSET__6EnSViaD__"